import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "w-100 overflow-auto",
  style: {"height":"50vh"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["colspan"]
const _hoisted_4 = ["onClick", "onKeydown"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = { key: 0 }

import { computed, type Component, type VNodeChild} from 'vue';

import { BrandLoader } from '@/components/global';

interface Column {
  label: string;
  key: string;
}

interface Identifiable {
  id?: number | string;
  [key: string]: any;
}

interface TableProps<T extends Identifiable> {
  columns: Column[];
  data?: T[];
  loadingData?: boolean;
  emptyText?: string | Component | VNodeChild;
  isResultNotFound?: boolean;
  zoom?: boolean;
  clickable?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Table',
  props: {
    columns: {},
    data: {},
    loadingData: { type: Boolean, default: false },
    emptyText: { type: [String, Object, Number, Boolean, null, Array], default: 'No data available' },
    isResultNotFound: { type: Boolean, default: false },
    zoom: { type: Boolean, default: false },
    clickable: { type: Boolean, default: true }
  },
  emits: ["clickRow"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const emptyTextFallback = computed(() => props.isResultNotFound ? 'No result found' : 'No data available');

const handleOnClick = (rowData: any) => {
  props.clickable && emit('clickRow', rowData);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", {
      style: _normalizeStyle({ width: '100%', height: __props.data && __props.data.length > 0 ? 'auto' : '100%' })
    }, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
            return (_openBlock(), _createElementBlock("th", {
              key: col.key,
              class: "text-nowrap",
              style: _normalizeStyle(__props.zoom ? { fontSize: 'var(--font-xs)' } : { fontSize: 'var(--font-sm)' })
            }, _toDisplayString(col.label), 5))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (__props.loadingData)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
              _createElementVNode("td", {
                colspan: __props.columns.length,
                class: "py-1 text-center"
              }, [
                _renderSlot(_ctx.$slots, "loading", {}, () => [
                  _createVNode(_unref(BrandLoader))
                ])
              ], 8, _hoisted_3)
            ]))
          : (__props.data && __props.data.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.data, (row, rowIndex) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.id ?? rowIndex,
                  tabindex: "0",
                  onClick: ($event: any) => (handleOnClick(row)),
                  onKeydown: _withKeys(($event: any) => (handleOnClick(row)), ["enter"]),
                  style: _normalizeStyle({ fontSize: __props.zoom ? 'var(--font-sm)' :  'var(--font-base)' }),
                  class: _normalizeClass(['table-list-row', __props.clickable ? 'table-cell-clickable' : ''])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: col.key,
                      class: "table-cell text-start text-nowrap"
                    }, [
                      _renderSlot(_ctx.$slots, "renderCell", {
                        rowIndex: rowIndex,
                        columnKey: col.key,
                        rowData: row
                      }, () => [
                        _createTextVNode(_toDisplayString(row[col.key] ?? '-'), 1)
                      ])
                    ]))
                  }), 128))
                ], 46, _hoisted_4))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                _createElementVNode("td", {
                  colspan: __props.columns.length,
                  class: "py-1 text-center"
                }, [
                  (_ctx.$slots.emptyText)
                    ? _renderSlot(_ctx.$slots, "emptyText", {}, undefined, undefined, 0)
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (typeof __props.emptyText === 'string')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.emptyText ?? emptyTextFallback.value), 1))
                          : (_openBlock(), _createBlock(_resolveDynamicComponent(__props.emptyText), { key: 1 }))
                      ], 64))
                ], 8, _hoisted_6)
              ]))
      ])
    ], 4)
  ]))
}
}

})